import { Link } from "react-router-dom";
import { Plus, Package } from "lucide-react";
import { productImgUrl } from "@/lib/imageUtils";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const inStock = product.quantity > 0;

  return (
    <div className="group bg-white border border-slate-200 rounded-md overflow-hidden hover:border-[#004E98]/30 hover:shadow-md transition-all" data-testid={`product-card-${product.id_product}`}>
      <Link to={`/produkt/${product.id_product}`} className="block aspect-square bg-slate-100 relative overflow-hidden">
        {productImgUrl(product, 'large') ? (
          <img src={productImgUrl(product, 'large')} alt={product.name} className="absolute inset-0 w-full h-full object-contain p-2" loading="lazy" onError={(e) => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }} />
        ) : null}
        <div className={`absolute inset-0 items-center justify-center text-slate-300 ${productImgUrl(product, 'large') ? 'hidden' : 'flex'}`}>
          <Package className="w-16 h-16" />
        </div>
        {product.on_sale === 1 && (
          <span className="absolute top-2 left-2 bg-red-100 text-red-700 border border-red-200 text-[10px] uppercase font-bold px-2 py-0.5 rounded-sm">Akce</span>
        )}
      </Link>
      <div className="p-3">
        <Link to={`/produkt/${product.id_product}`} className="block">
          <h3 className="text-sm font-medium text-slate-800 line-clamp-2 h-10 group-hover:text-[#004E98] transition-colors">{product.name}</h3>
        </Link>
        {product.reference && (
          <p className="text-xs text-slate-400 mt-1">Kod: {product.reference}</p>
        )}
        <div className="flex items-center gap-2 mt-2">
          <span className={`text-[10px] font-medium px-2 py-0.5 rounded-sm flex items-center gap-1 ${inStock ? 'bg-emerald-50 text-emerald-700 border border-emerald-100' : 'bg-slate-100 text-slate-500'}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${inStock ? 'bg-emerald-500' : 'bg-slate-400'}`}></span>
            {inStock ? 'Skladem' : 'Na dotaz'}
          </span>
        </div>
        <div className="flex items-center justify-between mt-3">
          <div>
            <div className="text-lg font-bold text-[#004E98]">{product.price_vat?.toFixed(2)} Kc</div>
            <div className="text-xs text-slate-400">{product.price?.toFixed(2)} Kc bez DPH</div>
          </div>
          <button
            onClick={(e) => { e.preventDefault(); addItem(product); }}
            className="w-9 h-9 bg-[#FF6B35] text-white rounded-sm flex items-center justify-center hover:bg-[#E85D2A] transition-colors active:scale-95"
            data-testid={`add-to-cart-${product.id_product}`}
          >
            <Plus className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
